import { MobiDocument } from './MobiDocument';

export class VieQuoRegimeAliDocument extends MobiDocument{
    private _id: string;
    private _rev: string;
    private id: number;
    private viequo_id : number;
    private type_regime: string;

    public constructor(viequoregime: any) {
        super();
        this._id = viequoregime._id;
        this._rev = viequoregime._rev;
        this.id = viequoregime.id;
        this.viequo_id = viequoregime.viequo_id;
        this.type_regime = viequoregime.type_regime;
    }


    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getViequo_id(): number {
        return this.viequo_id;
    }

    public setViequo_id(viequo_id: number): void {
        this.viequo_id = viequo_id;
    }

    public getType_regime(): string {
        return this.type_regime;
    }

    public setType_regime(type_regime: string): void {
        this.type_regime = type_regime;
    }

}